const WIKIPEDIA_API = "https://fr.wikipedia.org/w/api.php";

function buildArticleUrl(title) {
  return `https://fr.wikipedia.org/wiki/${encodeURIComponent(title.replace(/ /g, "_"))}`;
}

function cleanExtract(text) {
  return text.replace(/\s*\[\d+\]/g, "").trim();
}

export async function fetchWikipediaDefinition(word) {
  const trimmed = word.trim();
  if (!trimmed) {
    return { ok: false, reason: "empty" };
  }

  const url = new URL(WIKIPEDIA_API);
  url.searchParams.set("action", "query");
  url.searchParams.set("prop", "extracts");
  url.searchParams.set("exintro", "1");
  url.searchParams.set("explaintext", "1");
  url.searchParams.set("redirects", "1");
  url.searchParams.set("format", "json");
  url.searchParams.set("origin", "*");
  url.searchParams.set("titles", trimmed);

  const res = await fetch(url.toString());
  if (!res.ok) {
    return { ok: false, reason: "network" };
  }

  const data = await res.json();
  const pages = data?.query?.pages;
  if (!pages) {
    return { ok: false, reason: "network" };
  }

  const page = Object.values(pages)[0];
  if (!page || page.missing !== undefined) {
    return { ok: false, reason: "not-found", query: trimmed };
  }

  const extract = cleanExtract(page.extract || "");
  if (!extract) {
    return {
      ok: false,
      reason: "empty-page",
      query: trimmed,
      title: page.title,
    };
  }

  return {
    ok: true,
    title: page.title,
    extract,
    url: buildArticleUrl(page.title),
  };
}
